import { FC } from "react";
import { FileInput } from "./BulkUploadTrainingResourceDialog";
import { UploadedFile } from "./UploadedFile";

type Props = {
  files: FileInput[];
  updateFileName: (id: string, language: Language, value: string) => void;
  updateFileDescription: (
    id: string,
    language: Language,
    value: string,
  ) => void;
  removeFile: (id: string) => void;
  language: Language;
  getUploadProgress?: (fileId: string) => number;
  uploadingFiles?: string[];
};
export const UploadedFileList: FC<Props> = ({
  files,
  updateFileDescription,
  updateFileName,
  removeFile,
  language,
  getUploadProgress,
  uploadingFiles,
}) => {
  return (
    <div className="flex w-full flex-1 flex-col space-y-3 p-3">
      {files.map((file) => {
        return (
          <UploadedFile
            key={file.id}
            file={file}
            updateFileName={updateFileName}
            updateFileDescription={updateFileDescription}
            removeFile={removeFile}
            language={language}
            uploadProgress={getUploadProgress ? getUploadProgress(file.id) : 0}
            isUploading={
              uploadingFiles ? uploadingFiles.includes(file.id) : false
            }
          />
        );
      })}
    </div>
  );
};
